export const ACTIVE_USER_ID = "chat.ACTIVE_USER_ID";
export const CANCEL_ACTIVE_USER = "chat.CANCEL_ACTIVE_USER";
